import axios from 'axios';

const _base = import.meta.env.BASE_URL === '/' ? '' : import.meta.env.BASE_URL.replace(/\/$/, '');

export const appBasePath = _base;
export const appLoginPath = `${_base || ''}/login`;

export const api = axios.create({
  baseURL: `${_base}/api/v1`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      window.location.href = appLoginPath;
    }
    return Promise.reject(err);
  }
);
